import { FC } from 'react';
import { CircularProgress } from '@material-ui/core';

import { SLOT_PENDING_LABEL_PREFIX } from '../constants';
import { SlotMutationPhase } from '../types';

import styles from './SlotButton.module.scss';

interface SlotButtonProps {
  label: string;
  isSelected: boolean;
  isDisabled: boolean;
  isLocked: boolean;
  pendingPhase: SlotMutationPhase | null;
  onClick: () => void;
}

const SlotButton: FC<SlotButtonProps> = ({
  label,
  isSelected,
  isDisabled,
  isLocked,
  pendingPhase,
  onClick,
}) => {
  const pendingLabel = pendingPhase
    ? `${SLOT_PENDING_LABEL_PREFIX[pendingPhase]} ${label}`
    : undefined;

  const isCommitted = pendingPhase === 'committed';

  const isBusy = pendingPhase !== null && !isCommitted;

  const isLockedByOtherSlot = isLocked && pendingPhase === null;

  return (
    <button
      type="button"
      className={styles['slot-button']}
      disabled={isDisabled || isLocked || isBusy}
      data-selected={isSelected}
      data-pending={isBusy ? 'true' : undefined}
      data-committed={isCommitted ? 'true' : undefined}
      data-locked={isLockedByOtherSlot ? 'true' : undefined}
      aria-busy={isBusy}
      aria-label={pendingLabel}
      title={pendingLabel}
      onClick={onClick}
    >
      {isBusy ? <CircularProgress size={16} /> : label}
    </button>
  );
};

export default SlotButton;
